var StandardError = require("standard-error")

/**
 * Base error class
 * @param {any} msg 
 * @param {any} payload 
 */
function CSSDKError(msg, payload) {
  if (!payload) {
    payload = {}
  }
  StandardError.call(this, msg, payload)
}

CSSDKError.prototype = Object.create(StandardError.prototype, {
  constructor: { value: CSSDKError, configurable: true, writable: true }
})

/**
 * Error class thrown when communicating with API
 * @param {any} msg 
 * @param {any} payload 
 */
function WebApiError(msg, payload) {

  StandardError.call(this, msg, payload)
};

WebApiError.prototype = Object.create(CSSDKError.prototype, {
  constructor: { value: WebApiError, configurable: true, writable: true }
});

WebApiError.prototype.getStatusCode = function () {
  return this.payload.statusCode;
}

/**
 * Error class thrown when there is misconfiguration of SDK
 * @param {any} msg 
 * @param {any} payload 
 */
function ConfigurationError(msg, payload) {

  StandardError.call(this, msg, payload)
};

ConfigurationError.prototype = Object.create(CSSDKError.prototype, {
  constructor: { value: ConfigurationError, configurable: true, writable: true }
});

exports.CSSDKError = CSSDKError;
exports.WebApiError = WebApiError;
exports.ConfigurationError = ConfigurationError;


//////////////////
// WEBPACK FOOTER
// ./lib/core/error.js
// module id = 2
// module chunks = 0